import { Directive, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgControl } from '@angular/forms';
import { AbstractControl } from '@shared/modules/form/modules/abstracts/abstract-control';

@Directive()
export class AbstractInput extends AbstractControl implements OnInit {
  @Input() isDisabled: boolean;
  @Output() changed: EventEmitter<string> = new EventEmitter<string>();
  @Output() keyDownEnter: EventEmitter<string> = new EventEmitter<string>();

  protected constructor(public ngControl: NgControl) {
    super(ngControl);
  }

  ngOnInit(): void {
    this.setControlStatus();
  }

  onEnter($event: KeyboardEvent): void {
      $event?.stopPropagation?.();
      $event?.preventDefault?.();

      const value = ($event?.target as HTMLInputElement)?.value || undefined;

      this.keyDownEnter.emit(value);
  }

  onChange($event): void {
    const value = ($event.target as HTMLInputElement).value;

    this.value = this.config.type === 'number' ? +value : value;
    this._onChange(this.value);
    this.changed.emit(this.value);
    this.setControlStatus();
  }
}
